import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const ClientesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Clientes</PageTitle>
      <View />
    </>
  );
};

export { ClientesPage };
